import { Address } from './address';
import { Company } from './company';

export class CompanyAddress extends Address {
  company: Company = null;

  constructor() {
    super();
  }
}
